/** Link de texto (ações secundárias nas telas de acesso): petróleo, sublinhado no hover. */
export const textLinkClasses =
  'self-start rounded-sm text-body font-medium text-petroleo underline-offset-4 hover:underline'
